module.exports = __webpack_public_path__ + "static/flags/JN-a6d0516eda5129f9ac1e063874cb832f.gif";